export enum Endpoints {
    Configurations = '/application-configurations/aggregated'
}
